export const formatDuration = (duration: string | number) => {
  if (typeof duration === "string" && duration.includes(":")) {
    return duration;
  }

  const totalSeconds =
    typeof duration === "string" ? parseInt(duration, 10) || 0 : duration;
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  if (hours > 0) {
    return `${hours}:${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")}`;
  }

  return `${minutes}:${seconds.toString().padStart(2, "0")}`;
};
